var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35853 8.62985L10.4037 13.4609C10.4866 13.5411 10.5852 13.6047 10.6938 13.6481C10.8024 13.6915 10.919 13.7139 11.0366 13.7139C11.1543 13.7139 11.2708 13.6915 11.3794 13.6481C11.4881 13.6047 11.5866 13.5411 11.6695 13.4609C11.8355 13.3007 11.9287 13.084 11.9287 12.8581C11.9287 12.6322 11.8355 12.4155 11.6695 12.2553L7.25717 7.98L11.6695 3.74745C11.8355 3.58724 11.9287 3.37053 11.9287 3.14463C11.9287 2.91874 11.8355 2.70202 11.6695 2.54181C11.5869 2.46102 11.4885 2.39674 11.3799 2.35271C11.2712 2.30868 11.1546 2.28576 11.0366 2.2853C10.9187 2.28576 10.802 2.30868 10.6934 2.35271C10.5847 2.39674 10.4863 2.46102 10.4037 2.54181L5.35853 7.37291C5.26805 7.45298 5.19584 7.55016 5.14645 7.65832C5.09707 7.76649 5.07157 7.88329 5.07157 8.00138C5.07157 8.11946 5.09707 8.23627 5.14645 8.34443C5.19584 8.4526 5.26805 8.54978 5.35853 8.62985Z",
    fill: "#AC98F6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.09159373d516af4a5ca3df8c372b77b2.svg";
export { ForwardRef as ReactComponent };